import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { MenuItem, Select } from 'seagull';
import { billingTriggersTextsPath } from '~/business-logic/billingLogic';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useLocaleKeys } from '~/i18n';
import { connectControllerToTextField } from '~/utils/react-hook-form.utils';
import { getUpdatedTriggerIfInvalid } from './BillingTrigger.utils';
export const pricingTextsPath = 'billing.pricing';
export function validatePricing(param) {
    let { pricing, recurrencePeriod, texts } = param;
    if (recurrencePeriod === 'inStages' && pricing !== 'fixed') {
        return texts.mustBeFixedPriceForStages();
    }
    if (recurrencePeriod === 'onDemand' && pricing !== 'hour' && pricing !== 'unit') {
        return texts.mustBeVariablePriceForOnDemand();
    }
    return true;
}
const pricingOptionDefs = [
    {
        value: 'fixed',
        textKey: 'fixed',
        disabledOnBundle: false
    },
    {
        value: 'hour',
        textKey: 'hour',
        disabledOnBundle: false
    },
    {
        value: 'unit',
        textKey: 'unit',
        disabledOnBundle: false
    },
    {
        value: 'range',
        textKey: 'range',
        disabledOnBundle: true
    }
];
export default function PricingTextField(param) {
    let { isBundle, testId, serviceOrigin, isExistingService = false } = param;
    const { control, watch, trigger: triggerValidation, setValue, getValues } = useFormContext();
    const recurrencePeriod = watch('recurrencePeriod');
    const pricing = watch('pricing');
    const featureFlags = useFeatureFlags();
    const { t: billingTriggersTexts } = useLocaleKeys(billingTriggersTextsPath);
    const { t: pricingTexts } = useLocaleKeys(pricingTextsPath);
    useEffect(()=>{
        triggerValidation('pricing');
    }, [
        recurrencePeriod,
        triggerValidation
    ]);
    useEffect(()=>{
        if (!serviceOrigin) return;
        const currentData = getValues();
        const updatedTrigger = getUpdatedTriggerIfInvalid({
            t: billingTriggersTexts,
            currentTrigger: currentData.trigger,
            pricing,
            recurrencePeriod,
            serviceOrigin,
            isExistingService,
            featureFlags
        });
        if (updatedTrigger) {
            setValue('trigger', updatedTrigger, {
                shouldDirty: true
            });
        }
    }, [
        pricing,
        recurrencePeriod,
        serviceOrigin,
        isExistingService,
        featureFlags,
        setValue,
        getValues,
        billingTriggersTexts
    ]);
    return /*#__PURE__*/ _jsx(Controller, {
        control: control,
        name: "pricing",
        rules: {
            validate: (pricing)=>validatePricing({
                    pricing,
                    recurrencePeriod,
                    texts: pricingTexts.validation
                })
        },
        render: (renderProps)=>/*#__PURE__*/ _jsx(Select, _object_spread_props(_object_spread({}, connectControllerToTextField(renderProps, {
                alwaysShowErrors: true
            })), {
                label: pricingTexts.label(),
                testId: testId !== null && testId !== void 0 ? testId : 'sb-pricing',
                children: pricingOptionDefs.map((param)=>{
                    let { value, textKey, disabledOnBundle } = param;
                    const text = pricingTexts.options[textKey]();
                    return /*#__PURE__*/ _jsx(MenuItem, {
                        value: value,
                        testId: testId ? "".concat(testId, "-opt-").concat(value) : "sb-pricing-opt-".concat(value),
                        disabled: isBundle && disabledOnBundle,
                        tooltipProps: {
                            title: isBundle && disabledOnBundle ? pricingTexts.bundleNotSupported({
                                pricingType: text
                            }) : ''
                        },
                        children: text
                    }, value);
                })
            }))
    });
}
